module.exports = __webpack_public_path__ + "Sauer-nova_hala.jpg?d2958ce432d1f36c7e167469f05aff96";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reference/Sauer-nova_hala.jpg
// module id = 216
// module chunks = 0